/* Oceanse — avatar (senaryo) seçimi, galeri filtresi, paketler, renk seçimi, sepete ekleme */
(function () {
  function qs(r, s) { return r.querySelector(s); }
  function qsa(r, s) { return Array.prototype.slice.call(r.querySelectorAll(s)); }
  function money(cents) {
    var n = Math.round(cents / 100);
    return String(n).replace(/\B(?=(\d{3})+(?!\d))/g, '.') + ' ₺';
  }
  function getParam(name) {
    try { return new URLSearchParams(location.search).get(name); } catch (e) { return null; }
  }
  function pickAvatar(avatars) {
    var code = (getParam('senaryo') || '').toLowerCase().trim();
    if (code) { try { sessionStorage.setItem('oc_senaryo', code); } catch (e) {} }
    else { try { code = sessionStorage.getItem('oc_senaryo') || ''; } catch (e) {} }
    var found = null;
    avatars.forEach(function (a) { if (!found && code && a.codes.indexOf(code) > -1) found = a; });
    if (!found) avatars.forEach(function (a) { if (!found && a.def) found = a; });
    return found || avatars[0] || null;
  }

  function initRoot(root) {
    var data = {};
    try { data = JSON.parse(qs(root, 'script[data-oc-config]').textContent); } catch (e) { return; }
    var av = null;
    if (data.fixed) (data.avatars || []).forEach(function (a) { if (!av && a.key === data.fixed) av = a; });
    if (!av) av = pickAvatar(data.avatars || []);
    if (av) {
      root.setAttribute('data-av', av.key);
      qsa(root, '[data-oc-only]').forEach(function (el) {
        var on = (' ' + el.getAttribute('data-oc-only') + ' ').indexOf(' ' + av.key + ' ') > -1;
        el.style.display = on ? (el.getAttribute('data-oc-disp') || (el.tagName === 'SPAN' ? 'inline' : 'block')) : 'none';
      });
      Object.keys(av.colors || {}).forEach(function (k) { if (av.colors[k]) root.style.setProperty('--oc-' + k, av.colors[k]); });
      if (av.colors && av.colors.bg) document.documentElement.style.setProperty('--oc-page-bg', av.colors.bg);
      if (av.colors && av.colors.btn) document.documentElement.style.setProperty('--oc-page-acc', av.colors.btn);
    }

    /* Galeri: görsel alt metninde #ortak veya #avatar etiketi */
    var gal = qs(root, '[data-oc-gal]');
    if (gal) {
      var items = qsa(gal, '[data-tags]');
      var anyTagged = items.some(function (i) { return i.getAttribute('data-tags'); });
      var shown = 0;
      items.forEach(function (i) {
        var t = (i.getAttribute('data-tags') || '').toLowerCase();
        var ok = !anyTagged || t.indexOf('#ortak') > -1 || (av && t.indexOf('#' + av.key) > -1);
        i.style.display = ok ? '' : 'none'; if (ok) shown++;
      });
      var dots = qs(root, '[data-oc-dots]');
      if (dots) {
        dots.innerHTML = '';
        for (var d = 0; d < Math.min(shown, 16); d++) dots.appendChild(document.createElement('i'));
        var setDot = function () {
          var w = gal.clientWidth || 1, idx = Math.round(gal.scrollLeft / w);
          qsa(dots, 'i').forEach(function (x, j) { x.className = j === idx ? 'on' : ''; });
        };
        gal.addEventListener('scroll', function () { window.requestAnimationFrame(setDot); }, { passive: true }); setDot();
      }
    }

    /* Ses aracı: "dene" butonları mevcut ses aracını açar */
    qsa(root, '[data-oc-try]').forEach(function (b) {
      b.addEventListener('click', function () {
        var sel = data.trySelector || '';
        var target = null;
        try { target = sel ? document.querySelector(sel) : null; } catch (e) {}
        if (target) { target.click(); }
        else {
          var anchor = document.querySelector(data.tryAnchor || '#ses-araci');
          if (anchor) anchor.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      });
    });
    qsa(root, '[data-oc-scroll]').forEach(function (b) {
      b.addEventListener('click', function () {
        var t = qs(root, '[data-oc-target="' + b.getAttribute('data-oc-scroll') + '"]');
        if (t) t.scrollIntoView({ behavior: 'smooth', block: 'center' });
      });
    });

    /* Paketler + renk seçimi */
    var form = qs(root, '[data-oc-bundles]');
    if (!form || !data.product) return;
    var alias = { 'silver': 'Gümüş', 'gold': 'Bakır', 'mor': 'Lila', 'siyah': 'Metal', 'yeşil': 'Zümrüt', 'yesil': 'Zümrüt' };
    var variants = (data.product.variants || []).map(function (v) {
      var nm = alias[(v.title || '').toLowerCase()] || v.title;
      return { id: v.id, title: nm, available: v.available, price: v.price };
    });
    var swatches = data.swatches || {};
    var BANDS = [{ t: 'Siyah', c: '#1d1f22' }, { t: 'Lila', c: '#c6a3e3' }];
    var colorRows = qs(root, '[data-oc-colors]');
    var cta = qs(root, '[data-oc-atc]'), err = qs(root, '[data-oc-err]');
    var sticky = qsa(root, '[data-oc-sticky-price]');
    var bundles = qsa(form, '[data-k]');
    var defColor = av && av.color ? av.color.toLowerCase() : '';
    var state = { n: 0, k: 0, set: 0, picks: [], bands: [] };
    var defVariant = variants.filter(function (v) { return v.available && v.title.toLowerCase() === defColor; })[0] || variants.filter(function (v) { return v.available; })[0] || variants[0];

    var order = ['gümüş', 'metal', 'lila', 'zümrüt', 'bakır'];
    var palette = [defVariant].concat(order.map(function (nm) {
      return variants.filter(function (v) { return v.available && v.title.toLowerCase() === nm; })[0];
    }).filter(function (v) { return v && (!defVariant || v.id !== defVariant.id); }));
    palette = palette.filter(Boolean);
    function row(label, opts, isOn, onPick) {
      var r = document.createElement('div'); r.className = 'row';
      var lab = document.createElement('span'); lab.textContent = label; r.appendChild(lab);
      var sw = document.createElement('div'); sw.className = 'oc-sw';
      opts.forEach(function (o) {
        var btn = document.createElement('button'); btn.type = 'button';
        btn.title = o.title; btn.setAttribute('aria-label', label + ' rengi: ' + o.title);
        btn.style.background = o.color;
        if (o.disabled) btn.disabled = true;
        if (isOn(o)) btn.className = 'on';
        btn.addEventListener('click', function () { onPick(o); renderColors(); });
        sw.appendChild(btn);
      });
      r.appendChild(sw); colorRows.appendChild(r);
    }
    function renderColors() {
      colorRows.innerHTML = '';
      var pOpts = variants.map(function (v) { return { id: v.id, title: v.title, color: swatches[v.title.toLowerCase()] || '#ccc', disabled: !v.available }; });
      for (var i = 0; i < state.n; i++) (function (idx) {
        row((idx + 1) + '. çift', pOpts, function (o) { return state.picks[idx] === o.id; }, function (o) { state.picks[idx] = o.id; });
      })(i);
      if (state.set) {
        var bOpts = BANDS.map(function (b) { return { title: b.t, color: b.c }; });
        for (var j = 0; j < state.n; j++) (function (idx) {
          row(state.n > 1 ? (idx + 1) + '. göz bandı' : 'Göz bandı', bOpts, function (o) { return state.bands[idx] === o.title; }, function (o) { state.bands[idx] = o.title; });
        })(j);
      }
    }
    function select(k) {
      var cur = bundles.filter(function (b) { return +b.getAttribute('data-k') === k; })[0];
      if (!cur) return;
      var n = +cur.getAttribute('data-n') || 1;
      state.k = k; state.n = n; state.set = +(cur.getAttribute('data-set') || 0);
      while (state.picks.length < n) { var pv = palette[state.picks.length % palette.length] || defVariant; state.picks.push(pv ? pv.id : null); }
      state.picks = state.picks.slice(0, n);
      while (state.bands.length < n) state.bands.push('Siyah');
      state.bands = state.bands.slice(0, n);
      bundles.forEach(function (b) { b.classList.toggle('sel', b === cur); b.setAttribute('aria-pressed', b === cur ? 'true' : 'false'); });
      var sel = cur;
      sticky.forEach(function (s) { s.textContent = sel ? (sel.getAttribute('data-sticky-label') || sel.getAttribute('data-price-label')) : ''; });
      renderColors();
    }
    bundles.forEach(function (b) { b.addEventListener('click', function () { select(+b.getAttribute('data-k')); }); });
    var start = bundles.filter(function (b) { return b.hasAttribute('data-default'); })[0] || bundles[0];
    if (start) select(+start.getAttribute('data-k'));

    if (cta) cta.addEventListener('click', function () {
      var counts = {};
      state.picks.forEach(function (id) { if (id) counts[id] = (counts[id] || 0) + 1; });
      var items = Object.keys(counts).map(function (id) { return { id: +id, quantity: counts[id] }; });
      if (state.set) {
        var props = {};
        state.picks.forEach(function (id, i) { var v = variants.filter(function (x) { return x.id === id; })[0]; props[(i + 1) + '. çift rengi'] = v ? v.title : ''; });
        state.bands.forEach(function (t, i) { props[state.n > 1 ? (i + 1) + '. göz bandı rengi' : 'Göz bandı rengi'] = t; });
        items = [{ id: state.set, quantity: 1, properties: props }];
      }
      if (!items.length) return;
      cta.disabled = true; if (err) err.style.display = 'none';
      var toCheckout = data.afterAdd === 'checkout';
      /* Hızlı ödeme: tek adımda sepet linkiyle doğrudan ödeme sayfasına (sepeti de yeniler) */
      if (toCheckout) {
        var url = (window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart/' + items.map(function (it) { return it.id + ':' + it.quantity; }).join(',');
        if (items[0].properties) {
          var b = btoa(unescape(encodeURIComponent(JSON.stringify(items[0].properties)))).replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, '');
          url += '?properties=' + b;
        }
        window.location.href = url;
        return;
      }
      var drawer = toCheckout ? null : document.querySelector('cart-drawer');
      var body = { items: items };
      if (drawer && drawer.renderContents) { body.sections = 'cart-drawer,cart-icon-bubble'; body.sections_url = window.location.pathname; }
      var go = function () {
        fetch((window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart/add.js', {
          method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify(body)
        }).then(function (r) { if (!r.ok) throw r; return r.json(); })
          .then(function (res) {
            if (!toCheckout) cta.disabled = false;
            if (drawer && drawer.renderContents && res && res.sections) {
              try { drawer.classList.remove('is-empty'); drawer.renderContents({ id: items[0].id, sections: res.sections }); return; } catch (e) {}
            }
            window.location.href = toCheckout ? '/checkout' : '/cart';
          })
          .catch(function () { cta.disabled = false; if (err) err.style.display = 'block'; });
      };
      /* Doğrudan ödemeye giderken sepette önceki denemelerden kalan ürün olmasın */
      if (toCheckout) {
        fetch((window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart/clear.js', { method: 'POST', headers: { 'Accept': 'application/json' } }).then(go, go);
      } else go();
    });
    qsa(root, '[data-oc-sticky-btn]').forEach(function (b) {
      b.addEventListener('click', function () { form.scrollIntoView({ behavior: 'smooth', block: 'center' }); });
    });
  }

  function boot() { qsa(document, '[data-oc-root]').forEach(initRoot); }
  /* Sepetten geri dönünce (tarayıcı önbelleği) butonlar kilitli kalmasın */
  window.addEventListener('pageshow', function () { qsa(document, '[data-oc-atc]').forEach(function (b) { b.disabled = false; }); });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();
